import { Injectable } from '@angular/core';
import { PointsApiProviderService } from '@core/api';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { TPointResponse } from '../../view-models/point-response.model';

@Injectable({
  providedIn: 'root',
})
export class PointsPaginationService {
  constructor(private pointsApiProviderService: PointsApiProviderService) {}

  fetchPoints(workspaceId: string): Observable<TPointResponse[]> {
    return this.fetchPointsPagination(workspaceId);
  }

  private fetchPointsPagination(
    workspaceId: string,
    points: TPointResponse[] = [],
    pageNumber: string = '',
  ): Observable<TPointResponse[]> {
    return this.pointsApiProviderService.fetchPoints(workspaceId, pageNumber).pipe(
      switchMap((response) => {
        const nextPageAfter = response.pagination.nextPageAfter;
        const extendedPoints = [...points, ...response.points];

        if (nextPageAfter) {
          return this.fetchPointsPagination(workspaceId, extendedPoints, nextPageAfter);
        }

        return of(extendedPoints);
      }),
    );
  }
}
